import { useEffect } from 'react';
import { useAsyncQuery } from './useAsyncQuery';
import { listClubAccessRequests, MEMBERSHIP_REQUESTS_CHANGED } from '../lib/registerApi';

export function useClubAccessRequests(clubId: string | null, userId?: string) {
  const query = useAsyncQuery(async () => ({
    data: { clubId, userId, requests: clubId ? await listClubAccessRequests(clubId) : [] }, error: null,
  }), [clubId, userId], null, 'ClubAccessRequests');
  const { reload } = query;
  useEffect(() => {
    if (!clubId) return;
    const refresh = () => { if (document.visibilityState === 'visible') void reload(); };
    window.addEventListener(MEMBERSHIP_REQUESTS_CHANGED, refresh);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', refresh);
    return () => {
      window.removeEventListener(MEMBERSHIP_REQUESTS_CHANGED, refresh);
      window.removeEventListener('focus', refresh);
      document.removeEventListener('visibilitychange', refresh);
    };
  }, [clubId, reload]);
  return { ...query, requests: !query.loading && !query.error && query.data?.clubId === clubId
    && query.data?.userId === userId ? query.data.requests : [] };
}
